module.exports = __webpack_public_path__ + "img/logo.08e2afe7.jpg";